const Maintanance = () => {
    return <h2>Sorry! We're currently doing site maintenance.</h2>;
};

export default Maintanance;
